import React from "react";

const Footer = () => {
  return (
    <div className="flex justify-center">
      <a href="https://github.com/mertoztat" className="p-2 text-2xl">
        <i className="fa-brands fa-github"></i>
      </a>
      <a href="https://twitter.com/mertoztat" className="p-2 text-2xl">
        <i className="fa-brands fa-twitter"></i>
      </a>
      <a href="https://www.linkedin.com/in/mertoztat" className="p-2 text-2xl">
        <i className="fa-brands fa-linkedin"></i>
      </a>
    </div>
  );
};

export default Footer;
